import React from "react";
import AuthLeftPanel from "./AuthLeftPanel";

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex justify-center bg-white">
      <div className="grid lg:grid-cols-2 w-full max-w-[1440px]">

        {/* LEFT SIDE */}
        <AuthLeftPanel />

        {/* RIGHT SIDE */}
        <div className="flex items-center justify-center bg-white py-6 w-full">
          <div className="w-full max-w-[85%]">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;